import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { API } from "../global";
import "./allQuestions.css";
import { QuestionsList } from "./QuestionsList";


export function AllQuestionsWrapper() {
    
    const navigate = useNavigate();
    const [questionsData, setQuestionsData] = useState([]);
    useEffect(function () {
        fetch(`${API}/questions/`)
            .then((data) => data.json())
            .then((questionsData) => setQuestionsData(questionsData))
            .catch(() => {
                console.log("error");
            });
    }, []);

    const askQuestion = () => {
        var userDetails = localStorage.getItem("user");
        userDetails = JSON.parse(userDetails);
        if(userDetails && userDetails.userName) {
            navigate("/questions/askquestion");
        } else {
            navigate("/users/signup");
        }
    }

    return (
        <div className='questionsBodyContent'>
          <div className="questionsHeader">
            <h1>All Questions</h1>
            <Button type="button" variant="contained" onClick={() => askQuestion()}>Ask Question</Button>
          </div>
          <QuestionsList questionsData={questionsData}/>
        </div>
    );
}


